import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import ActiveSimulations from "./components/ActiveSimulations";
import CompletedSimulations from "./components/CompletedSimulations";
import NewOrderModal from "./components/NewOrderModal";
import {
  ConfirmationDialog,
  useConfirmationDialogController,
} from "../presentation/confirmation-dialog";
import {
  getStoredSimulations,
  OrderStates,
  clearStoredSimulations,
} from "./helpers";
import api from "../../services/api";
import "./style.css";

export default ({ id }) => {
  const [showModal, setShowModal] = useState(false);
  const [storedSimulations, setStoredSimulations] = useState(
    getStoredSimulations()
  );
  const [isResetting, setIsResetting] = useState(false);

  const onResetSimulation = async () => {
    if (isResetting) {
      return;
    }
    setIsResetting(true);
    try {
      await api.resetOmsSimulator();
      const storedOrderIds = storedSimulations.map(
        (storedOrder) => storedOrder.orderId
      );
      await api.resetTempoSimulator(storedOrderIds);
      clearStoredSimulations();
      setStoredSimulations([]);
    } catch (error) {
      const errorMessage = "An error occurred clearing simulated orders";
      console.log(errorMessage, error);
      alert(errorMessage);
    }
    setIsResetting(false);
  };

  const confirmationDialogController = useConfirmationDialogController({
    onConfirm: onResetSimulation,
  });
  const confirmResetMessage =
    "Are you sure you want to reset the simulation? This will stop all in progress simulations";
  const onUpdateStoredSimulations = () => {
    setStoredSimulations(getStoredSimulations());
  };

  return (
    <div>
      <h4 className="simulators-heading">
        <b>Demonstrate Oracle Simphony Integration: </b> Use this tool to
        simulate an order & Tempo experience
      </h4>
      <div className="simulators-button-wrapper">
        <Button
          color="primary"
          variant="contained"
          className="simulators-button"
          onClick={() => setShowModal(true)}
        >
          Create New
        </Button>
        <Button
          color="secondary"
          variant="contained"
          className="simulators-button"
          disabled={isResetting}
          onClick={confirmationDialogController.openDialog}
        >
          Reset Simulation
        </Button>
      </div>
      <ConfirmationDialog
        message={confirmResetMessage}
        controller={confirmationDialogController}
      />
      <ActiveSimulations
        onStoredSimulationsUpdated={onUpdateStoredSimulations}
        simulations={storedSimulations.filter(
          (simulation) => simulation.status === OrderStates.CREATED
        )}
      />
      <CompletedSimulations
        simulations={storedSimulations.filter(
          (simulation) => simulation.status !== OrderStates.CREATED
        )}
      />
      <NewOrderModal
        onStoredSimulationsUpdated={onUpdateStoredSimulations}
        showModal={showModal}
        onHideModal={() => setShowModal(false)}
        accountId={id}
      />
    </div>
  );
};
